// Decides whether a matrix question renders the optional right-side statement
// column (semantic differential — a left and a right pole per row).
//
// Gated by the per-question `MatrixBipolar` flag, stored as a real boolean
// (not the legacy 'true'/'false' string convention) to avoid type drift.
// Existing matrices have no flag, so they stay single-column by default.
const shouldShowMatrixRightColumn = (field) => {
    return field?.MatrixBipolar === true
}

export default shouldShowMatrixRightColumn
